(function () {
  'use strict';

  var STORAGE_KEY = 'sinestesia_diario_likes';

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(store) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {
      /* localStorage no disponible (modo privado, etc): el like sigue funcionando visualmente en la sesión */
    }
  }

  function getEntry(store, articleId) {
    return store[articleId] || { count: 0, liked: false };
  }

  function renderButton(btn) {
    var articleId = btn.getAttribute('data-article-id');
    var store = readStore();
    var entry = getEntry(store, articleId);
    var countEl = btn.querySelector('.diario-like__count');

    if (countEl) {
      countEl.textContent = entry.count;
    }
    btn.classList.toggle('is-liked', !!entry.liked);
    btn.setAttribute('aria-pressed', entry.liked ? 'true' : 'false');
  }

  function toggleLike(btn) {
    var articleId = btn.getAttribute('data-article-id');
    var store = readStore();
    var entry = getEntry(store, articleId);

    if (entry.liked) {
      entry.liked = false;
      entry.count = Math.max(0, entry.count - 1);
    } else {
      entry.liked = true;
      entry.count = entry.count + 1;
    }

    store[articleId] = entry;
    writeStore(store);

    // Actualiza todos los botones de este mismo artículo presentes en la página
    // (por si aparece tanto en el listado como, eventualmente, en otro lugar)
    var allButtonsForArticle = document.querySelectorAll(
      '[data-diario-like][data-article-id="' + CSS.escape(articleId) + '"]'
    );
    allButtonsForArticle.forEach(function (b) {
      renderButton(b);
      b.classList.add('is-animating');
      window.setTimeout(function () {
        b.classList.remove('is-animating');
      }, 220);
    });
  }

  function initLikeButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-diario-like]');

    buttons.forEach(function (btn) {
      if (btn.dataset.diarioLikeBound === 'true') return;
      btn.dataset.diarioLikeBound = 'true';

      renderButton(btn);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleLike(btn);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLikeButtons(document);
  });

  // Por si el listado se vuelve a renderizar via AJAX nav del tema
  document.addEventListener('shopify:section:load', function (evt) {
    initLikeButtons(evt.target);
  });

  window.SinestesiaDiarioLikes = {
    init: initLikeButtons
  };
})();
